import React, { useContext } from "react";
import Snowfall from "react-snowfall";
import ThemeContext from "../contexts/ThemeContext";

const ChristmasEffects = () => {
    const { isChristmasTheme } = useContext(ThemeContext);

    if (!isChristmasTheme) return null;

    return (
        <Snowfall
            snowflakeCount={200}
            style={{
                position: "fixed",
                width: "100vw",
                height: "100vh",
                zIndex: 9999,
                pointerEvents: "none",
            }}
        />
    );
};

export default ChristmasEffects;
